var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhatsappFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3816",
    d: "M9 0a9 9 0 00-7.292 14.271l-1.12 3.343 3.453-1.1A9 9 0 109 0zm5.051 12.765A2.474 2.474 0 0112.343 14c-.459.092-1.047.165-3.049-.661a10.914 10.914 0 01-4.316-3.82 4.924 4.924 0 01-1.029-2.631 2.751 2.751 0 01.882-2.112 1.209 1.209 0 01.882-.312 1.485 1.485 0 01.294.018c.257.018.386.018.551.422.2.5.716 1.745.771 1.873a.533.533 0 01.037.478 1.437 1.437 0 01-.276.4c-.129.147-.257.257-.386.422-.11.147-.257.294-.11.533a7.4 7.4 0 001.414 1.745 6.268 6.268 0 002.039 1.249.526.526 0 00.606-.092 7.107 7.107 0 00.68-.9.481.481 0 01.624-.184c.239.073 1.469.7 1.727.827s.422.184.478.294a1.624 1.624 0 01-.111 1.216z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/whatsapp_full.34d51fa5a54ec361bd8cd972b998bfe1.svg";
export { SvgWhatsappFull as ReactComponent };